<script setup>
// UI-FILTROS-01 (D9): a caixa só desenhada, para dentro de um item que já é o controle (a opção da
// pílula é um <button>, e <input> não pode ficar dentro de <button>). Sem role nem aria-checked:
// quem anuncia o estado é o item pai.
defineProps({
  checked: { type: Boolean, default: false },
  indeterminate: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
</script>

<template>
  <span
    aria-hidden="true"
    class="relative flex items-center justify-center flex-shrink-0 border rounded size-4 transition-colors duration-200"
    :class="[
      checked || indeterminate
        ? 'bg-n-brand border-n-brand'
        : 'border-n-control',
      { 'opacity-50': disabled },
    ]"
  >
    <!-- Os mesmos traços do Checkbox.vue; o indeterminado vence o marcado, como no nativo. -->
    <svg
      v-if="indeterminate"
      viewBox="0 0 14 14"
      fill="none"
      class="w-3.5 h-3.5 stroke-white"
    >
      <path
        d="M3 7L11 7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-else-if="checked"
      viewBox="0 0 14 14"
      fill="none"
      class="w-3.5 h-3.5 stroke-white"
    >
      <path
        d="M3 8L6 11L11 3.5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>
